import { useHead } from "@unhead/react"

export const SITE_NAME = "Vitamin Vital Portal"
export const SITE_URL = "https://www.vitaminavital.com"

interface SeoHeadProps {
  title: string
  description: string
  path: string
  type?: "website" | "article"
}

function SeoHead({ title, description, path, type = "article" }: SeoHeadProps) {
  const url = `${SITE_URL}${path}`

  useHead({
    title,
    meta: [
      { name: "description", content: description },
      { property: "og:site_name", content: SITE_NAME },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:url", content: url },
      { property: "og:type", content: type },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description }
    ],
    link: [{ rel: "canonical", href: url }]
  })

  return null
}

export default SeoHead
